import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { MStepper } from '@argalis-apps/angular-global';
import { MFormation } from '@argalis-apps/models';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { FormOptionService } from '../../services/cart/form-option/form-option.service';

@Component({
  selector: 'ags-form-option',
  templateUrl: './form-option.component.html',
  styleUrls: ['./form-option.component.scss']
})
export class FormOptionComponent implements OnInit, MStepper.IStepComponent {
  @HostBinding('class') themeFlag: string;
  @Input() public step: MStepper.IStep;
  @Output() public backStep = new EventEmitter<any>();
  @Output() public validation = new EventEmitter<any>();
  public form: MFormation.CFormInfo;

  constructor(private cartConfigService: CartConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.cartConfigService.themingClassName}`;
    this.form = new MFormation.CFormInfo(this.step.dataInput);
  }

  public backToPrevStep() {
    this.backStep.emit(false);
  }

  public goToNextStep() {
    //TODO  => save function
    this.validation.emit(true);
  }

  public countCheckedOptions(): number {
    let count = 0;
    for (const opt of this.form.optionInfo.options) {
      if (opt.subscribed) count += 1;
    }
    return count;
  }
}
